import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-session-modal',
  templateUrl: './new-session-modal.component.html',
  styleUrls: ['./new-session-modal.component.scss']
})
export class NewSessionModalComponent implements OnInit {

  constructor(
      public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }
  onClose() {
    this.activeModal.close(false);
  }

  submit() {
    this.activeModal.close(true);
  }

    protected readonly close = close;
}
